import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FileInputComponent} from 'ngx-material-file-input';
import {ReplaySubject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {DOCUMENT} from '@angular/common';
import {delay, first, takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {SoldPolicyImportService} from '../../../shared/services/sold-policy-import.service';
import {FileBase64} from '../../../shared/components/file-drag-and-drop/file-drag-and-drop.component';
import {Router} from '@angular/router';

@Component({
  selector: 'app-sold-policy-import',
  templateUrl: './sold-policy-import.component.html',
  styleUrls: ['./sold-policy-import.component.scss']
})
export class SoldPolicyImportComponent implements OnInit, OnDestroy {

  @ViewChild('fileInput') fileInputComponent: FileInputComponent;

  importCompanyId: ReplaySubject<number> = new ReplaySubject<number>(1);
  soldPolicyImportFormValid = false;
  soldPolicyImportForm: FormGroup;
  companyControl: FormControl;
  insuranceCompanyControl: FormControl;
  fileControl: FormControl;
  fileMaxSize = 5242880 * 8;
  processingRequest = false;
  formErrors = {};

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private soldPolicyImportService: SoldPolicyImportService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
  ) {
    this.soldPolicyImportForm = fb.group({
      name: fb.control('', [Validators.required]),
      company: this.companyControl = fb.control('', []),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      fileContent: fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.soldPolicyImportForm.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      )
      .subscribe(() => {
        this.soldPolicyImportFormValid = this.soldPolicyImportForm.valid;
      });

    this.companyControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((companyId: number) => this.importCompanyId.next(companyId));
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  import(): void {
    if (!this.soldPolicyImportForm.valid) {
      this.soldPolicyImportForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.soldPolicyImportForm, this.formErrors);
    this.formErrors = {};

    this.soldPolicyImportService.import(this.soldPolicyImportForm.value)
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snack.open('Rozpoczynanie importowania danych', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.router.navigate(['/sprzedaz-lista-importow']);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas tworzenia importu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.soldPolicyImportForm, this.formErrors);
        }
      })
    ;
  }

  resetFileValue(): void {
    this.fileControl.setValue('');
    this.fileInputComponent.clear();
  }

  fileSelected(file: FileBase64): void {
    this.soldPolicyImportForm.get('fileContent').setValue(file.base64);
    this.soldPolicyImportForm.get('name').setValue(file.filename);
  }
}
